import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/announcement/Full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
